export { CertificationSimulations, type CertificationSimulationsProps } from './CertificationSimulations';